import { useEffect, useState } from 'react';
//
// TLS Dose Engine About Page
//
import gSession from '../script/session';
import gUtilities from '../script/utilities';

const AboutPage = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchVersion() {
            let request = {
                service: "db.query",
                collection: "dcs_configuration",
                many: false,
                query: {
                    name: "version"
                }
            };

            let response = await gSession.exchange(request);
            if (response.isError) {
                gUtilities.showError("Version", response.message);
            } else {
                setData(response);
            }
        }

        fetchVersion();
    }, []);

    return (
        <div>
            <h1><span></span></h1>
            <div className="card text-white bg-primary mb-3">
                <div className="card-header">About</div>
                {data &&
                    <div className="card-body">
                        <h4 className="card-title">TLS Dose Calculation Service</h4>
                        <p className="card-text">Monte Carlo dose calculation for BNCT treatment.</p>
                        <p className="card-text">Account: {data.account}</p>
                        <p className="card-text">Agent Version: {data.agent}</p>
                        <p className="card-text">Client Version: {data.client}</p>
                        <br></br>
                        <p className="card-text"><i>{data.copyright}</i></p>
                    </div>
                }
            </div>
        </div>
    );
}

export default AboutPage;